import { RadioTileGroup } from '@noissue-ui-kit/oldBranding/radioTile'
import { useEditorFullScreenMode } from '../../UnifiedEditorProvider'

export function DoneButton({ onDone }: { onDone: () => void }) {
  const { isFullScreen } = useEditorFullScreenMode()

  return (
    <RadioTileGroup
      onChange={() => onDone()}
      options={[{ displayLabel: 'Done', key: 'done' }]}
      radioGroupClassName={`grid-cols-1 font-semibold ${
        isFullScreen ? 'ml-auto' : 'hidden'
      }`}
      radioItemClassName="px-16 hover:bg-black-10"
      selected={null}
    />
  )
}
